import React, { useState, useEffect } from "react";
import "./EditGameModal.css";


function EditGameModal({ isOpen, originalGame, onEdit, onCancel }) {
 const [form, setForm] = useState({
  date: "",
  time: "",
  location: "",
  location_url: "",
 });

 useEffect(() => {
  if (isOpen && originalGame) {
   setForm({
    date: originalGame.date || "",
    time: originalGame.time || "",
    location: originalGame.location || "",
    location_url: originalGame.location_url || "",
   });
  }
 }, [isOpen, originalGame]);

 if (!isOpen) return null;

 return (
  <div className="modal-overlay">
   <div className="modal-content">
    <h3>Edit Game</h3>

    <input
     type="date"
     value={form.date}
     onChange={(e) => setForm({ ...form, date: e.target.value })}
    />

    <input
     type="time"
     value={form.time}
     onChange={(e) => setForm({ ...form, time: e.target.value })}
    />

    <input
     type="text"
     placeholder="Location"
     value={form.location}
     onChange={(e) => setForm({ ...form, location: e.target.value })}
    />

    <input
     type="url"
     placeholder="Location URL"
     value={form.location_url}
     onChange={(e) => setForm({ ...form, location_url: e.target.value })}
    />

    <div className="modal-actions">
     <button onClick={onCancel}>Cancel</button>
     <button onClick={() => onEdit({ ...originalGame, ...form })}>Save</button>
    </div>
   </div>
  </div>
 );
}

export default EditGameModal;